export default {"src":"/_next/static/media/explore.92a24aac.svg","height":700,"width":1512,"blurWidth":0,"blurHeight":0};